import { ActionIcon } from '@mantine/core'

import IconChevronLeft from 'src/icons/IconChevronLeft'

import ApplicationProgressBar from './ApplicationProgressBar'
import Header from './Header'
import StepFooter from './StepFooter'

const ApplicationScreenWrapper = ({
  groupName = '',
  title = '',
  description = '',
  error = '',
  children,
  application = {} as { company?: { companyId?: string } },
  handleSubmit = () => {},
  handleCancel = () => {},
  goBack = () => {},
  updateLoading = false,
  hideBackButton = false,
  hideButtons = false,
  saveButtonDisabled = false,
  saveButtontext = null,
  fullBleed = false,
  headerOnly = false,
  backText = 'Back',
}) => {
  const isSignatureScreen = title === 'Sign your application'

  return (
    <div
      className={`flex h-[100dvh] flex-col gap-2 py-3 sm:gap-5 ${
        isSignatureScreen && 'bg-[#FBFBFC]'
      }`}
    >
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, resizes-content"
      />
      <div className="flex flex-1 flex-col gap-2 sm:gap-5">
        {headerOnly ? (
          <Header companyId={application?.company?.companyId} />
        ) : (
          <ApplicationProgressBar application={application} />
        )}

        <div
          className={`flex h-full flex-col px-4 pt-2 sm:pt-4 ${
            fullBleed ? 'justify-start' : 'items-center justify-between'
          }`}
        >
          <div className="flex w-[90%] flex-col items-center gap-3 sm:items-start">
            <div className="text-lg font-semibold text-doubleNickel-gray-900 sm:text-left">
              {groupName}
            </div>
            {(title || !hideBackButton) && (
              <div className="flex w-full flex-row justify-start">
                {!hideBackButton && (
                  <div className="flex-1 sm:hidden">
                    <ActionIcon onClick={goBack} variant="subtle">
                      <IconChevronLeft className="h-4 w-4 fill-none stroke-doubleNickel-gray-500" />
                    </ActionIcon>
                  </div>
                )}
                <div className="flex-2 text-xl font-semibold text-doubleNickel-gray-800 sm:text-left sm:text-2xl">
                  {title}
                </div>
                {!hideBackButton && <div className="flex-1 sm:hidden"></div>}
              </div>
            )}

            <div className="w-full text-base text-doubleNickel-gray-600">
              {description}
            </div>
          </div>

          {/*
            Screens own their own width when full-bleed. The default centres a
            90%-wide column and pads it, which a screen whose children set no
            width of their own collapses inside — it shrinks to its content and
            floats in the middle of the phone.
          */}
          <div
            className={
              fullBleed
                ? 'flex min-h-0 w-full flex-1 flex-col'
                : `flex w-[90%] flex-col items-center gap-4 pb-3 pt-6 sm:grid sm:grid-cols-3 sm:gap-10 sm:pb-4 sm:pt-10 ${
                    hideButtons ? 'my-auto' : ''
                  }`
            }
          >
            {children}
          </div>

          {error && (
            <div className="text-md font-medium text-doubleNickel-error-500">
              {error}
            </div>
          )}
          {!hideButtons && (
            <StepFooter
              primaryText={saveButtontext ?? 'Continue'}
              onPrimary={handleSubmit}
              primaryLoading={updateLoading}
              primaryDisabled={saveButtonDisabled}
              onBack={hideBackButton ? null : handleCancel}
              backText={backText}
              className="pb-3 pt-2 sm:w-[90%] sm:py-4"
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ApplicationScreenWrapper
